export enum DefaultView {
  ALL = "all",
  OPEN = "open",
  ASSIGNED = "assigned",
  MENTIONS = "mentions",
  SENT = "sent",
  DRAFTS = "drafts",
  AI_CONVERSATIONS = "ai_conversations",
  SPAM = "spam",
  ARCHIVED = "archived",
}

export const DEFAULT_VIEW_DISPLAY_NAMES: Record<DefaultView, string> = {
  [DefaultView.ALL]: "All tickets",
  [DefaultView.OPEN]: "Open",
  [DefaultView.ASSIGNED]: "Assigned to me",
  [DefaultView.MENTIONS]: "Mentions",
  [DefaultView.SENT]: "Sent",
  [DefaultView.DRAFTS]: "Drafts",
  [DefaultView.AI_CONVERSATIONS]: "AI conversations",
  [DefaultView.SPAM]: "Spam",
  [DefaultView.ARCHIVED]: "Archived",
};

export const DEFAULT_VIEW_IDS: ReadonlySet<string> = new Set(
  Object.values(DefaultView),
);

export function isDefaultView(value: string): value is DefaultView {
  return DEFAULT_VIEW_IDS.has(value);
}
